export default "__VITE_ASSET__DUAehWv0__"